<template>
    <div>
        <h1>Détails d'un matériel</h1>

        <div class="text-center text-danger my-2" v-if="loading">
            <b-spinner class="align-middle"></b-spinner>
             <strong>Chargement des données…</strong>
        </div>
        <b-alert v-else-if="errors.length" variant="danger" show>
            <p v-for="error in errors" :key="error" class="mb-0">{{error}}</p>
        </b-alert>
        <div v-else>
            <h2>État général</h2>
            <ul>
                <li>Modèle : {{ deviceModel }}</li>
                <li>Numéro de série : {{ serial }}</li>
                <li>Intitulé : {{ label }}</li>
                <li>Dernier contact : {{ lastSeen || 'Inconnu' }}</li>
                <li>Statut :
                    <status-summary :showText="true" :show-icons="true" :statuses="summary"/>
                </li>
                <li v-if="values.length">Dernières valeurs remontées :
                    <ul>
                        <li v-for="value in values" v-bind:key="value.key">{{ value.key }} : {{ value.value }} {{ value.time}}</li>
                    </ul>
                </li>
            </ul>
            <h2>Événements en cours</h2>
            <events-table :events="events"/>
            <div v-if="children.length > 0">
                <h2>Matériels rattachés</h2>
                <p class="text-info">Cliquez sur une ligne pour obtenir plus d'informations sur les événements en cours.</p>
                <devices-table :devices="children" :show-actions="false" :loading="false" show-events/>
            </div>
            <h2>Notifications</h2>
            <p class="text-info">Sélectionnez les événements pour lesquels vous souhaitez recevoir une notification de début et de fin par mail.</p>
            <ul v-if="notifications.length">
                <li v-for="n in sortedNotifications" :key="n">
                    <span :class="statusClass(n)">
                    <font-awesome-icon :icon="statusIcon(n)"/>
                     {{statusLabel(n)}} 
                    </span>
                    <font-awesome-icon icon="trash" @click="removeNotification(n)"/>
                </li>
            </ul>
            <b-form @submit.prevent.stop="addNotification" class="mb-4">
                <input type="hidden" name="id" :value="this.id"/>
                <b-form-group label="Événement" label-for="event">
                    <b-select v-model="notification" id="event" required>
                        <b-form-select-option value="ALARM">{{statusLabel('ALARM')}}</b-form-select-option>
                        <b-form-select-option value="FAULTY">{{statusLabel('FAULTY')}}</b-form-select-option>
                        <b-form-select-option value="UNREACHABLE">{{statusLabel('UNREACHABLE')}}</b-form-select-option>
                    </b-select>
                </b-form-group>
                <div class="text-center">
                    <b-button type="submit" variant="primary" :disabled="processing">Ajouter</b-button>
                </div>
            </b-form>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import {API_URL, REFRESH_FREQUENCY} from "../../variables";
    import StatusSummary from "../StatusSummary";
    import DevicesTable from "./DevicesTable";
    import EventsTable from "../EventsTable";
    import {EVENTS} from "../../events";

    function updateData() {
        this.errors = [];
        axios
            .get(API_URL + "/user/device/details", {params: {id: this.id}})
            .then(response => {
                for (let p in response.data) {
                    this[p] = response.data[p];
                }
            })
            .catch(() => this.errors.push("Une erreur est survenue lors du traitement de la requête"))
            .finally(() => {
                this.loading = false;
                this.timeout = window.setTimeout(() => updateData.call(this), REFRESH_FREQUENCY * 1000);
            });
    }

    export default {
        name: "DeviceDetails",
        props: ["id"],
        components: {EventsTable, DevicesTable, StatusSummary},
        data() {
            return {
                deviceModel: null,
                serial: null,
                label: null,
                summary: [],
                events: [],
                values: [],
                errors: [],
                children: [],
                notifications: [],
                loading: true,
                timeout: null,

                // FIXME This should probably be in a notification component
                notification: null,
                processing: false
            };
        },
        computed: {
            sortedNotifications() {
                return this.notifications.concat().sort();
            }
        },
        mounted() {
            updateData.call(this);
        },
        beforeDestroy() {
            window.clearTimeout(this.timeout);
        },
        methods: {
            addNotification() {
                this.processing = true;
                axios
                    .post(API_URL + "/user/notifications", {
                        user_device: this.id,
                        event: this.notification
                    })
                    .then(response => this.notifications = response.data)
                    .finally(() => this.processing = false);
            },
            removeNotification(ev) {
                axios
                    .delete(API_URL + "/user/notifications", {
                        params: {
                            user_device: this.id,
                            event: ev
                        }
                    })
                    .then(response => this.notifications = response.data)
            },
            statusIcon(key) {
                return EVENTS[key].icon;
            },
            statusLabel(key) {
                return EVENTS[key].text;
            },
            statusClass(key) {
                return "text-" + EVENTS[key].color;
            }
        }
    }
</script>

<style scoped>
    svg[data-icon=trash] {
        cursor: pointer;
    }
</style>